<div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
  <h1 class="h2">Asset Types</h1>
</div>

<div *ngIf="loading">loading</div>

<app-table [dataSource]="dataSource" [displayedColumns]="displayedColumns" [route]="'route'" [checkBoxes]="true"
  *ngIf="!loading" (rowClick)="rowClick($event)" (deleteClick)="delete($event)" [clickToEdit]="false"
  (editClick)="edit($event)" (createClick)="add()" [permission]="permissions.AssetTypes" uniqueKey="asset-types"></app-table>